import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ['TOKEN', 'token', 'refreshToken', 'userInfo', 'paymentDatas', 'query', 'detailData', 'bottomData']
    })
  ],
  state: {
    sign: {
      key: "AIGWObuQU",
      publicKey: "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9x4Q1noPhiYP8pgWjJVn7JY5JWMQDE5GCw/ge/JlM7xJEW7o2wN/D4fXXdtQEljkFnmhugGLvD1Yb8c6DQGvBLbhT0egz4kQ6E6DrLkimFMCUJlQdVBzzHqvnhDCR/NDb66/GiDxyiOVVTWxVmk4E2TeWLvn73h4GrEV+nlUqiwIDAQAB",
    },
    showID: '10746',
    TOKEN: '',
    token: '',
    refreshToken: '',
    userInfo: null,
    paymentDatas: null,
    showConfig: {},
    siteConfig: {},
    lngModel: ['cn', 'Cn'],
    routePath: {
      'cn': ['首页'],
      'en': ['Home']
    },
    bannerUrl: '',
    newsDetail: {},

    nowPageData: {},
    // 首页“底部”模块数据
    bottomData: null,
    BannerType: 'index',
    EssayData: {},
    isPC: 'true',
    SearchDirectory: {
      'cn': [],
      'en': []
    },
    parentData: {},
    detailData: {
      componentKey: '',
      data: {},
      nav: '',
    },
    peopleInfo: {},
    peopleInArea: '',
    peoplePayWay: '',
    invoiceInfo: {},
    abstractPaperId: '',
    regformInfo: {},
    allPaperInfo: {},
    userRemark: '',
    payInfo: {
      status: '0',
      order_id: '',
      way: '',
    },
    isFormal: '0',
    canSubmitThesis: '0',
    canSubmitAbstract: '0',
    RecordNumber: '',
    inMiniProgram: '0',
    // Add: order payload passed from previous page
    query: null,
  },
  getters: {
    // 获取token
    getToken: (state) => state.token,
    // 获取TOKEN
    getTOKEN: (state) => state.TOKEN,
    // 获取refreshToken
    getRefreshToken: (state) => state.refreshToken,
    // 获取用户信息
    getUserInfo: (state) => state.userInfo,
    // 检查是否已登录
    isLoggedIn: (state) => !!state.token,
    // 获取支付数据
    getPaymentData: (state) => state.paymentDatas,
  },
  mutations: {
    setTOKEN(state, data) {
      state.TOKEN = data
      state.token = data
    },
    setPaymentData(state, data) {
      state.paymentDatas = data
    },
    setShowConfig(state, data) {
      state.showConfig = data
    },
    setSiteConfig(state, data) {
      state.siteConfig = data
    },
    setLngModel(state, data) {
      state.lngModel = data
    },
    setRoutePath(state, data) {
      state.routePath = data
    },
    setBannerUrl(state, data) {
      state.bannerUrl = data
    },
    setNewsDetail(state, data) {
      state.newsDetail = data
    },
    setnowPageData(state, data) {
      state.nowPageData = data
    },
    setBannerType(state, data) {
      state.BannerType = data
    },
    // 保存首页底部模块数据
    setBottomData(state, data) {
      state.bottomData = data || null
    },
    setEssayData(state, data) {
      state.EssayData = data
    },
    setisPC(state, data) {
      state.isPC = data
    },
    setSearchDirectory(state, data) {
      state.SearchDirectory = data
    },
    setparentData(state, data) {
      state.parentData = data
    },
    setdetailData(state, data) {
      state.detailData = data
    },
    setpeopleInfo(state, data) {
      state.peopleInfo = data
    },
    setpeopleInArea(state, data) {
      state.peopleInArea = data
    },
    setpeoplePayWay(state, data) {
      state.peoplePayWay = data
    },
    setinvoiceInfo(state, data) {
      state.invoiceInfo = data
    },
    setabstractPaperId(state, data) {
      state.abstractPaperId = data
    },
    setregformInfo(state, data) {
      state.regformInfo = data
    },
    setallPaperInfo(state, data) {
      state.allPaperInfo = data
    },
    setuserRemark(state, data) {
      state.userRemark = data
    },
    setpayInfo(state, data) {
      state.payInfo = data
    },
    setisFormal(state, data) {
      state.isFormal = data
    },
    setCanSubmitThesis(state, data) {
      state.canSubmitThesis = data
    },
    setCanSubmitAbstract(state, data) {
      state.canSubmitAbstract = data
    },
    setRecordNumber(state, data) {
      state.RecordNumber = data
    },
    setinMiniProgram(state, data) {
      state.inMiniProgram = data
    },
    setToken(state, token) {
      state.token = token
      state.TOKEN = token
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setRefreshToken(state, token) {
      state.refreshToken = token
    },
    clearUserAuth(state) {
      state.token = ''
      state.TOKEN = ''
      state.refreshToken = ''
      state.userInfo = null
    },
    // Add: save order payload for Place page
    setOrderPayload(state, payload) {
      state.query = payload || null
    },
  },
  actions: {
    // 登录成功后的操作
    loginSuccess({ commit }, { token, refreshToken, userInfo }) {
      commit('setToken', token)
      commit('setRefreshToken', refreshToken)
      commit('setUserInfo', userInfo)
    },
    // 登出操作
    logout({ commit }) {
      commit('clearUserAuth')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    // 更新token
    updateToken({ commit }, token) {
      commit('setToken', token)
    },
    // 更新refreshToken
    updateRefreshToken({ commit }, refreshToken) {
      commit('setRefreshToken', refreshToken)
    },
    // 更新用户信息
    updateUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    },
    // 保存支付数据
    // savePaymentData({ commit }, paymentData) {
    //   commit('setPaymentData', paymentData)
    // }
  },
  modules: {}
})

export default store;
